// THIS FILE IS AUTOGENERATED. DO NOT EDIT
/* eslint-disable */
/* tslint:disable */
export * from './Pager'